import {MuWidget} from "mu-widget/lib/MuWidget";

export class UiCharCounter extends MuWidget {
	beforeIndex() {
		const newContainer = document.createElement('div');
		this.container.setAttribute('mu-id', 'input');
		this.container.classList.add('input-group');
		this.container.parentElement?.insertBefore(newContainer, this.container);
		newContainer.appendChild(this.container);
		const info = document.createElement('span');
		info.classList.add('input-group-addon');
		info.setAttribute('mu-id', 'info');
		newContainer.appendChild(info);
		const errorLabel = document.createElement('span');
		errorLabel.setAttribute('mu-for', );
		this.container = newContainer;
	}

	afterIndex() {
		this.update();
	}

	input_input() {
		this.update();
	}

	private update() {
		this.ui.info.innerText = this.ui.input.value.length.toString() + ' / ' + this.ui.input.maxLength.toString();
	}
}